var map = {
	"./adventure-6.mp3": 66029,
	"./adventure.mp3": 44894,
	"./card-flip.mp3": 36528,
	"./chimpo-speak.mp3": 24950,
	"./chubby.mp3": 64606,
	"./deck-tour/adventures-music/adventure1.mp3": 68444,
	"./deck-tour/adventures-music/adventure2.mp3": 82407,
	"./deck-tour/adventures-music/adventure3.mp3": 18391,
	"./deck-tour/adventures-music/adventure4.mp3": 41466,
	"./deck-tour/adventures-music/adventure5.mp3": 45212,
	"./deck-tour/adventures-music/adventure6.mp3": 41980,
	"./deselect-2.mp3": 68190,
	"./dojo-in.mp3": 10346,
	"./dojo-out.mp3": 44112,
	"./door-open.mp3": 12824,
	"./museum/chimp-museum.mp3": 17453,
	"./museum/museum.mp3": 71165,
	"./running-water.mp3": 29506,
	"./running.mp3": 4010,
	"./select-og.mp3": 41603,
	"./select.mp3": 2869,
	"./stake.mp3": 891,
	"./train-all.mp3": 9889,
	"./unstaking.mp3": 28357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60946;